//=============================================================================
// Contents   : HRDB
//              部署異動一覧
//              GetDepartmentTransferList
// Author     : RV小寺
// LastUpdate : 2023/3/28
// Since      : 2022/12/16
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  

/* ====== React ====== */
import React from "react";

/* ====== CSS ====== */

/* ====== Image ====== */

/* ====== Component Js/Jsx ====== */

/* ====== Style ====== */
import { GetListTemp } from "01Pages/Template/GetListTemp";
/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  
/* ベース64スイッチ */


/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */  

/* ========= 一覧テンプレート ========= */
export const GetDepartmentTransferList = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== useWatchを定義 ====== */ 

    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */

    /* ====== sessionStorageからの情報を定義 ====== */ 

    /* ====== localStorageからの情報を定義 ====== */ 

    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 

    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */

    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */

    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */
    /* ====== 取得API項目の設定 ====== */
	const getConfig = {
        key:[
            {name:'sarLiteral' ,        base64:true},
            {name:'sarYear' ,           base64:false},
            {name:'sarMonth' ,          base64:false},
        ],
        payload:[
            {name:'changeDate',            base64:false},
            {name:'empNmb',                base64:false},
            {name:'empFullName',           base64:true},
            {name:'empiSttsName',          base64:true},
            {name:'newDptName',            base64:true},
            {name:'newDptCd',              base64:false},
            {name:'newDptHqName',          base64:true},
            {name:'newDptPartName',        base64:true},
            {name:'newDptRomName',         base64:true},
            {name:'newDptGpName',          base64:true},
            {name:'newDptOrd',             base64:false},
            {name:'exDptCd',               base64:false},
            {name:'exDptName',             base64:true},
            {name:'exDptHqName',           base64:true},
            {name:'exDptPartName',         base64:true},
            {name:'exDptRomName',          base64:true},
            {name:'exDptGpName',           base64:true},
            {name:'exDptOrd',              base64:false},
            {name:'lastUdr',               base64:true},
            {name:'lastUpDate',            base64:false},
        ]              
    };
    /* ======== テーブルの設定 ======== */
    /*------ ヘッダの設定 ------*/
    // id       : 項目名
    // id2       : 項目名2
    // rowSpan  : 2~ (縦に結合)
    // colSpan	: 2~ (横に結合)
    // align	: 整列(横方向) Center/inherit/justify/left/right
    // sortTable: true(ソート)
    // fixed	: 位置固定 true
    // left		: 左からの位置	0~
    // right	: 右からの位置 0~
    // width    : セルの幅
    // label1	: 表示名(1段目)
    // label2	: 表示名(2段目)
    // mark     : 入力必須を表す*を表示　true

    /* ====== テーブルヘッダーを定義 ====== */
    const headData = [
    	{ id: 'changeDate', align: 'left', width: '100px', sortTable:true, label1: '異動日' ,fixed:true,left:'0px'},//異動日
        { id: 'empNmb', align: 'left', width: '115px', sortTable:true, label1: '従業員番号' ,fixed:true,left:'105px' },//従業員番号
        { id: 'empFullName', align: 'left', width: '120px', sortTable:true, label1: '氏名',fixed:true,left:'225px',borderRight:'1px solid #c0c0c0' },//氏名
        { id: 'empiSttsName', align: 'left', width: '130px', sortTable:true, label1: '雇用形態'},//雇用形態
    	{ id: 'newDptCd', align: 'left', width: '110px', sortTable:true, label1: '新部署',label2: 'コード' },//新部署コード
    	{ id: 'newDptHqName', align: 'left', width: '250px', sortTable:true, label1: '新部署' },//新部署
        { id: 'newDptOrd', align: 'left', width: '100px', sortTable:true, label1: '新部署順' },//新部署順
        { id: 'exDptCd', align: 'left', width: '110px', sortTable:true, label1: '元部署',label2: 'コード' },//元部署コード
        { id: 'exDptHqName', align: 'left', width: '250px', sortTable:true, label1: '元部署'},//元部署
        { id: 'exDptOrd', align: 'left', width: '100px', sortTable:true, label1: '元部署順' },//元部署順
        { id: 'lastUdr', align: 'left', width: '120px', sortTable:true, label1: '最終更新者' },//最終更新者
        { id: 'lastUpDate', align: 'left', width: '120px', sortTable:true, label1: '最終更新日'},//最終更新日
        
    ];
    /*====== BodyCellの設定 ======*/
    // name		    : 項目名
    // name2		: 項目名2 値を２つ受け取りたい場合
    // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
    // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
    // width        : selectの幅調整用
    // color        : 文字の色
    // backgroundColor: 背景の色
    // checkBox     : チェックボックスの名前  *input,checkBox
    // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
    // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
    // func         : 処理 *button,iconButton,select
    // value		: btnFuncで受け取りたい値 *button,iconButton
    /* ====== テーブルデータを定義 ====== */
    const bodyData = [
        { name: 'changeDate', type: 'dateLabel',  align: 'left',fixed:true,left:'0px'},
        { name: 'empNmb', type: 'label', fixed:true, align: 'left',left:'105px'},
        { name: 'empFullName', type: 'label', fixed:true, align: 'left',left:'225px',borderRight:'1px solid #c0c0c0'},
        { name: 'empiSttsName', type: 'label',  align: 'left'},
        { name: 'newDptCd', type: 'label',  align: 'left',},
        { name: 'newDptHqName', name2:'newDptPartName', name3:'newDptRomName', name4:'newDptGpName', type: 'label',  align: 'left'},
        { name: 'newDptOrd', type: 'label',  align: 'left'},
        { name: 'exDptCd', type: 'label',  align: 'left',},
        { name: 'exDptHqName', name2:'exDptPartName', name3:'exDptRomName', name4:'exDptGpName', type: 'label',  align: 'left',},
        { name: 'exDptOrd', type: 'label',  align: 'left'},
        { name: 'lastUdr', type: 'label',  align: 'left'},
        { name: 'lastUpDate', type: 'timeLabel',  align: 'left'},
        
    ];

    /* ======== エクセルの設定 ======== */
    const excelConfig = [
        { id:'changeDate', name:'異動日', type:'date'},
        { id:'empNmb', name:'従業員番号', type:'normal'},
        { id:'empFullName', name:'氏名', type:'normal'},
        { id:'empiSttsName', name:'雇用形態', type:'normal'},
        { id:'newDptCd', name:'新部署コード', type:'normal'},
        { id:'newDptHqName', name:'新本部', type:'normal'},
        { id:'newDptPartName', name:'新部', type:'normal'},
        { id:'newDptRomName', name:'新室', type:'normal'},
        { id:'newDptGpName', name:'新G', type:'normal'},
        { id:'newDptOrd', name:'新部署順', type:'normal'},
        { id:'exDptCd', name:'元部署コード', type:'normal'},
        { id:'exDptHqName', name:'元本部', type:'normal'},
        { id:'exDptPartName', name:'元部', type:'normal'},
        { id:'exDptRomName', name:'元室', type:'normal'},
        { id:'exDptGpName', name:'元G', type:'normal'},
        { id:'exDptOrd', name:'元部署順', type:'normal'},
        { id:'lastUdr', name:'最終更新者', type:'normal'},
        { id:'lastUpDate', name:'最終更新日', type:'time'}
    ]

    /* ======== ページヘッダーの設定 ======== */
    /*------ ページヘッダーの設定 ------*/
    // id         : 項目名
    // name       : 項目名
    // type       : 種類 input/select/checked/searchButton/clearButton
    // range      : selectbox中身
    // type       : 種類 input/select/checked/searchButton/clearButton
    // width      : 幅幅調整用
    // maxLength  : 最大桁数を定義
    // minLength  : 最小桁数を定義
    // placeholder: Input内のテキスト
    // required   : 必須定義
    // disabled   : 操作不可
    // func       : 処理 *button,iconButton,select
    // checked    :defoltCheckを定義

    /* ====== 検索欄(左)を定義 ====== */
    /* 今日の日付を取得 */
    let today = new Date();
    /* yyyy-mm-ddの形に変える */
    const year = `${today.getFullYear()}`;//年を取得
    const month = `${('00' + (today.getMonth()+1)).slice(-2)}`//月を取得
    /* ====== 検索初期値を定義 ====== */
    const defaultSearch = {
        sarYear:year,
        sarMonth:month,
        sarLiteral:'',
    }
    const searchContentsLeft = [
        {id:'sarYear',name:'対象年',type:'year',required:false, requireCheckItem:'sarMonth'},
        {id:'sarMonth',name:'対象月',type:'month',required:false, requireCheckItem:'sarYear'},
        {id:'sarLiteral',type:'input',name:'検索文字',placeholder:'',maxLength:50,width:'280px', pattern:'keyword'},
        {id:'search',type:'searchButton'},
        {id:'clear',type:'clearButton'},
    ];
    
    /* ====== 検索欄(右)を定義 ====== */
    const searchContentsRight = [
        {id:'excel',type:'excelButton', excelTitle:'部署異動一覧', excelConfig:excelConfig},   
    ];


    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */

    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
        <>
			<GetListTemp
				listType='list'//一覧タイプ(list:編集なし/listEditable:編集可/listOrderBy:表示順更新)
                initialSearch={true}//初期検索有無
                searchCount={true}//検索件数表示
				pageTitle='部署異動一覧'//画面タイトル
                searchContentsLeft={searchContentsLeft}//検索欄左設定
				searchContentsRight={searchContentsRight}//検索欄右設定
				apiPath='/employee/getlistdepartmenttransfer'//一覧取得のApiPath
                defaultSearch={defaultSearch}//初期検索値
				getConfig={getConfig}//テーブル取得設定
				headData={headData}//テーブルヘッダ設定
				bodyData={bodyData}//テーブルボディ設定
			/>
        </>
    );
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */ 